import React, {Fragment} from 'react';

import {ForgotPassword} from '../../component'


const Forgot: React.FC = (props: any) => {

    const {token} = props.match.params;

    return (
        <Fragment>
            <div className="app-wrapper min-vh-100 bg-white">
                <div className="app-main min-vh-100">
                    <div className="app-content p-0">
                        <div className="app-inner-content-layout--main">
                            <div className="flex-grow-1 w-100 d-flex align-items-center">
                                <div className="bg-composed-wrapper--content">
                                    <ForgotPassword token={token}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};


export default Forgot;



